<template>
    <TprmModal :additional-class-name="className" open title="Mapping" @close="$emit('close')">
        <LogoLoader v-if="progress" class="h-full w-full flex items-center justify-center" />
        <slot v-else />

        <template #footer>
            <NewButton
                v-if="!progress"
                data-test-id="CollateralMappingModal__saveButton"
                color="primary"
                @click="$emit('input', true)"
            >
                Save
            </NewButton>
        </template>
    </TprmModal>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { LogoLoader } from '@evidentid/dashboard-commons/components/LogoLoader';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    const componentName = 'CollateralMappingModal';
    // PRODUCT-26110 QA fixes4: declares every event this component `$emit`s -- without a
    // declared `emits`, Vue 3 warns "Component emitted event 'close'/'input' but it is
    // neither declared in the emits option nor as an 'onClose'/'onInput' prop" every time
    // it fires.
    export default defineComponent({
        name: componentName,
        components: {
            NewButton,
            TprmModal,
            LogoLoader,
        },
        props: {
            progress: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            additionalClassName: {
                type: String as PropType<string>,
                default: '',
            },
        },
        emits: [ 'close', 'input' ],
        computed: {
            className(): string {
                const additionalClassName = this.additionalClassName ? ` ${this.additionalClassName}` : '';
                return `${componentName}${additionalClassName}`;
            },
        },
    });
</script>
